
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!


export class GenStateRestorationMetric {

    auc: number;
    eventDuration: number;
    impactDuration: number;
    impactLevel: number;
    impactLevelRank: number;
    impactRate: number;
    recoveryDuration: number;
    recoveryDurationRank: number;
    recoveryImpactRatio: number;
    recoveryRate: number;
    recoveryRateRank: number;
    stateAbbreviation: string;
    stateId: number;
    stateName: string;

    constructor();
    constructor( jsonObj: any );
    constructor( genStateRestorationMetric: GenStateRestorationMetric);

    constructor( input?: GenStateRestorationMetric ) {
        if ( input && typeof input !== 'number' ) {
            this.auc = input.auc; // float [number]
            this.eventDuration = input.eventDuration; // float [number]
            this.impactDuration = input.impactDuration; // float [number]
            this.impactLevel = input.impactLevel; // float [number]
            this.impactLevelRank = input.impactLevelRank; // float [number]
            this.impactRate = input.impactRate; // float [number]
            this.recoveryDuration = input.recoveryDuration; // float [number]
            this.recoveryDurationRank = input.recoveryDurationRank; // float [number]
            this.recoveryImpactRatio = input.recoveryImpactRatio; // float [number]
            this.recoveryRate = input.recoveryRate; // float [number]
            this.recoveryRateRank = input.recoveryRateRank; // float [number]
            this.stateAbbreviation = input.stateAbbreviation; // string [string]
            this.stateId = input.stateId; // int [number]
            this.stateName = input.stateName; // string [string]
       }
    }

    static jsonResponseToList(arr: any[]): GenStateRestorationMetric[] {
        if (arr && arr.map) {
          return arr.map(a => new GenStateRestorationMetric(a));
        } else {
          return [];
        }
    }
}

